(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.stickyNavbar = {
    attach: function (context, settings) {
      window.addEventListener('scroll', function(e) {
        document.getElementById('navbar-main').classList.toggle('sticky', window.scrollY > 0);
      }, {passive: true});
    }
  };

  Drupal.behaviors.menu_responsive = {
    attach: function (context, settings) {
      once('menu_responsive', document.querySelectorAll('.toggle-menu'), context).forEach(function (menu) {

        menu.onclick = function () {
          document.getElementsByTagName('body')[0].classList.toggle('show-frontMenu');

          document.querySelectorAll('#menu-side-navigation [data-bs-target]').forEach(btn => {
            if (!document.getElementsByTagName('body')[0].classList.contains('show-frontMenu')) {
              btn.setAttribute('aria-expanded', 'false');
              btn.classList.remove('show');
              btn.nextElementSibling.classList.remove('show');
            }
          });

          document.querySelectorAll('#menu-desktop-navigation [data-bs-target]').forEach(btn => {
            if (!document.getElementsByTagName('body')[0].classList.contains('show-frontMenu')) {
              btn.classList.remove('active');
            }
          });
        }

      });
    }
  };

  Drupal.behaviors.bs_dropdown_menu = {
    attach: function (context, settings) {
      once('bs_dropdown_menu', document.querySelectorAll('.dropdown-menu'), context).forEach(function (menu) {

        menu.onclick = function (e) {
          e.stopPropagation();
        }

      });
    }
  };

  Drupal.behaviors.bs_target_menu = {
    attach: function (context, settings) {
      once('bs_target_menu', document.querySelectorAll('#menu-desktop-navigation [data-bs-target]'), context).forEach(function (navlink) {

        navlink.onclick = function (ev) {
          ev.preventDefault();
          document.getElementsByTagName('body')[0].classList.add('show-frontMenu');

          const target = document.querySelector(`#menu-side-navigation [data-key="${ev.target.dataset.key}"]`);
          if (target !== null || target !== undefined) {
            document.querySelectorAll('#menu-side-navigation [data-bs-target]').forEach((btn, key) => {
              if (ev.target.dataset.key !== btn.dataset.key) {
                btn.setAttribute('aria-expanded', 'false');
                btn.classList.remove('show');
                btn.nextElementSibling.classList.remove('show');
              } else {
                if (ev.target.classList.contains('active')) {
                  btn.setAttribute('aria-expanded', 'false');
                  btn.classList.remove('show');
                  btn.nextElementSibling.classList.remove('show');
                } else {
                  btn.setAttribute('aria-expanded', 'true');
                  btn.classList.add('show');
                  btn.nextElementSibling.classList.add('show');
                }
              }
            });

            document.querySelectorAll('#menu-desktop-navigation [data-bs-target]').forEach(btn => {
              if (ev.target.dataset.key !== btn.dataset.key) {
                btn.classList.remove('active')
              } else {
                if (btn.classList.contains('active')) {
                  btn.classList.remove('active');
                } else {
                  btn.classList.add('active');
                }
              }
            });
          }
          ev.stopPropagation();
        }

      });
    }
  };

  Drupal.behaviors.headerSearchBlock = {
    attach: function (context, settings) {
      once('headerSearchBlock', document.querySelectorAll('.toggle-main-search'), context).forEach(function (search) {

        search.onclick = function () {
          document.getElementById('header-search').classList.toggle('hide');
        }

      });
    }
  };

  Drupal.behaviors.sliderBsCarouselPauseControl = {
    attach: function (context, settings) {
      once('sliderBsCarouselPauseControl', document.querySelectorAll('.carousel-control-pause'), context).forEach(function (control) {

        control.onclick = function (ev) {
          const carousel = ev.target.parentElement.parentElement.parentElement;
          const carouselInstance = bootstrap.Carousel.getInstance(carousel);

          if (carouselInstance !== null) {
            if (carousel.dataset.bsPause == "false") {
              carouselInstance.pause(); // Pausar el carousel si está en movimiento
              carousel.dataset.bsPause = "true";
            } else {
              carouselInstance.cycle(); // Reanudar el carousel si está pausado
              carousel.dataset.bsPause = "false";
            }
          }
        }

      });
    }
  };
})(Drupal, once);
